<template>
  <div id="Informacje">
    <template v-for="(inform, key, index) in info">
    <div id="info-field" class="bgInfo" v-if="inform.text !== '' && inform.delay === 0" :class='[inform.type, key]' :key='index'>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg> - {{inform.text}}
      </span>
      <button style="background: red;color: white;font-weight: bold;border: none;" @click="close_info()" v-if="inform.out === 'click'">X</button>
    </div>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'Informacje',
  mixins: [app],
  data () {
    return {
    }
  },
  watch: {
    info: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        if (newValue.brak_miejsca_przod.text !== '') {
          this.changeInfoTime('brak_miejsca_przod', newValue.brak_miejsca_przod)
        }
        if (newValue.brak_miejsca_tyl.text !== '') {
          this.changeInfoTime('brak_miejsca_tyl', newValue.brak_miejsca_tyl)
        }
        if (newValue.mozliwa_kolizja.text !== '') {
          this.changeInfoTime('mozliwa_kolizja', newValue.mozliwa_kolizja)
        }
      }
    }
  },
  computed: {
    ...mapGetters('app', ['dialogInfo']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['info'])
  },
  methods: {
    changeDepth () {
      this.changeValueInputs('glebokosc_szafy', 'active', false)
    },
    changeInfoTime (key, info) {
      var self = this
      if (info.out === 'time') {
        setTimeout(function () { self.$store.commit('app/SET_INFORMATION', [key, '']) }, 4000)
      }
    },
    close_info () {
      this.$store.commit('app/SET_INFORMATION', ['mozliwa_kolizja', '', 1])
    }
  }
}
</script>

<style scoped>
#Informacje {
  font-size: 16px;
  /* border: 1px solid #00c3ff; */
  position: fixed;
  z-index: 5;
  background: #fff;
  width: 100%;
}
.bgInfo {
  /* width: 100%;
  text-align: left;
  padding: 5px;
  background: #fff;
  color: white; */
width: 100%;
text-align: left;
padding: 5px;

}
.mozliwa_kolizja button {
  background: none;
  border:none;
  cursor: pointer;
  font-weight: 600;
}
.mozliwa_kolizja span {
  background: none;
  border:none;
  margin-left: 8px;
  font-weight: 600;
}
.brak_miejsca_przod span {
  background: none;
  border:none;
  margin-left: 8px;
  font-weight: 600;
}
.brak_miejsca_tyl span {
  background: none;
  border:none;
  margin-left: 8px;
  font-weight: 600;
}
.warning {
  color: blue;
}
.danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Information.vue